import { PdfViewerController } from './pdf-viewer.controller';
import template from './pdf-viewer.html';

export const pdfViewerComponent = {
  name: 'pdfViewerComponent',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  controller: PdfViewerController,
  transclude: true,
  bindings: {
    url: '<',
    redirect: '<',
    scale: '@',
    height: '@',
    overlay: '<'
  }
};
